// BUILD-042 partial forms release (Builder 07:45 Phoenix, Oct 12) — HR feature availability.
//
// "Create fictional person" calls POST /admin/fictional-fixture-employees, which in turn needs the
// platform-identity fixture route. Neither is part of this partial release (the identity route's
// atomic-creation fix is a separate BUILD-039 effort, and the deployed Admin function is preserved
// unchanged). So the control is UNAVAILABLE by default.
//
// This is a build-time opt-in, deliberately defaulting to false: only the exact string 'true'
// enables it, so a missing or mistyped value fails to the safe (disabled) state. It is a UX
// honesty control, not a security control — the route does not exist in the release backend.
export const CREATE_FICTIONAL_PERSON_AVAILABLE = import.meta.env.VITE_HR_CREATE_FICTIONAL_PERSON === 'true';
